module.exports = __webpack_public_path__ + "img/mzy01.ad55aa6a.jpg";